<div class="container">
  <h5 class="text-start mb-0 font-size-18">{{ 'pick.player.rules.title' | translate }}</h5>

  <div class="col-12 games-rules-container mt-lg-3">
    <div class="row">
      <div ngbAccordion #a="ngbAccordion" [destroyOnHide]="false" class="mt-3 w-100 mt-lg-0">
        <div ngbAccordionItem id="ngb-panel-0">
          <div ngbPanelHeader>
            <h2 ngbAccordionHeader class="mt-0">
              <button ngbAccordionButton class="font-size-14">{{ 'pick.player.rules1.title' | translate }}</button>
            </h2>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <div class="row py-0">
                <div class="content col-12">
                  <div class="fantasy">
                    <div
                      class="font-size-14"
                      [innerHTML]="'pick.player.rules1.description' | translate | markdownTranslate"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div ngbAccordionItem id="ngb-panel-1">
          <div ngbPanelHeader>
            <h2 ngbAccordionHeader class="mt-0">
              <button ngbAccordionButton class="font-size-14">{{ 'pick.player.rules2.title' | translate }}</button>
            </h2>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <div class="row">
                <div class="content col-12">
                  <div class="fantasy">
                    <div
                      class="font-size-14"
                      [innerHTML]="'pick.player.rules2.description' | translate | markdownTranslate"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div ngbAccordionItem id="ngb-panel-2">
          <div ngbPanelHeader>
            <h2 ngbAccordionHeader class="mt-0">
              <button ngbAccordionButton class="font-size-14">{{ 'pick.player.rules3.title' | translate }}</button>
            </h2>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <div class="row">
                <div class="content col-12">
                  <div class="fantasy">
                    <div
                      class="font-size-14"
                      [innerHTML]="'pick.player.rules3.description' | translate | markdownTranslate"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div ngbAccordionItem id="ngb-panel-3">
          <div ngbPanelHeader>
            <h2 ngbAccordionHeader class="mt-0">
              <button ngbAccordionButton class="font-size-14">{{ 'pick.player.rules4.title' | translate }}</button>
            </h2>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <div class="row">
                <div class="content col-12">
                  <div class="fantasy">
                    <div
                      class="font-size-14"
                      [innerHTML]="'pick.player.rules4.description' | translate | markdownTranslate"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
